pageId = 'page-member-settings-email'
page = '#' + pageId

$ ->
  $(document).on 'ajax:success', "#{ page } .form-settings-email", (e, result) ->
    if result.success
      simple.dialog.message
        content: result.msg
